<template>
          <section class="section section section-shaped my-0 overflow-hidden">
            <div class="shape shape-style-1 bg-gradient-warning shape-skew" ref="showMore">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
            <div class="container py-0">
                <div class="row row-grid align-items-center">
                    <div class="col-md-6 order-lg-2 ml-lg-auto">
                        <div class="position-relative pl-md-5">
                            <img src="img/ill/ill-2.svg" class="img-center img-fluid">
                        </div>
                    </div>
                    <div class="col-lg-6 order-lg-1">
                        <div class="d-flex px-3">
                            <div>
                                <icon name="fa fa-cloud" size="lg" class="bg-gradient-blue" color="secondary" shadow
                                      rounded></icon>
                            </div>
                            <div class="pl-4">
                                <h4 class="display-3 text-white">Cloud Computing</h4>
                                <!-- <p class="text-white">Every multi-skilled developer must .</p> -->
                            </div>
                        </div>
                        <card shadow class="shadow-lg--hover mt-5">
                            <div class="d-flex px-3">
                                <div>
                                    <icon name="fa fa-database" gradient="default" color="white" shadow
                                          rounded></icon>
                                </div>
                                <div class="pl-4">
                                    <h5 class="title text-default">BackEnd</h5>
                                    <p>GCP (PostgreSQL, Kubernetes, Cloud Functions, Event Arc)</p>
                                    <p>AWS (NoSQL DynamoDB, CloudWatch, API Gateway, Cognito, EC2, Lambda/Serverless in Java using Native Compilation using GraalVM)</p>
                                    <p>SpringIO (Boot, Security, Data, Batch, Hibernate, Liquibase)</p>
                                    <div>
                                        <badge type="primary" rounded>AWS</badge>
                                        <badge type="primary" rounded>Serverless</badge>
                                        <badge type="primary" rounded>SpringIO</badge>
                                    </div>
                                </div>
                            </div>
                        </card>
                        <card shadow class="shadow-lg--hover mt-5">
                            <div class="d-flex px-3">
                                <div>
                                    <icon name="fa fa-chrome" gradient="warning" color="white" shadow
                                          rounded></icon>
                                </div>
                                <div class="pl-4">
                                    <h5 class="title text-warning">FrontEnd</h5>
                                    <p>VueJS, Angular, WebPack, NPM</p>
                                    <p>Android Studio / Kotlin, XCode / Swift</p>
                                    <div>
                                        <badge type="warning" rounded>VueJS</badge>
                                        <badge type="warning" rounded>Mobile</badge>
                                    </div>
                                </div>
                            </div>
                        </card>
                    </div>
                </div>
            </div>
        </section>
</template>

<script>
export default {
}
</script>

<style>

</style>
